import { useCallback } from 'react';

import { useNavigate, useParams } from '@xing-com/crate-core-router';
import { getXingJobsSlugPath } from '@xing-com/crate-core-routes';
import type { XingJobsApplySlugPathParams } from '@xing-com/crate-core-routes';
import { useSearchParameter } from '@xing-com/crate-hooks-use-search-parameter';

export const useReturnToJobPage = (): (() => void) => {
  const { getSearchParameter } = useSearchParameter();
  const { slug } = useParams<XingJobsApplySlugPathParams>();
  const navigate = useNavigate();

  return useCallback(() => {
    const params = new URLSearchParams();

    const ijt = getSearchParameter('ijt');
    if (ijt) {
      params.set('ijt', ijt);
    }

    const urlParams = params.toString();
    navigate(
      `${getXingJobsSlugPath({ slug })}${urlParams.length > 0 ? `?${urlParams}` : ''}`,
      { replace: true }
    );
  }, [getSearchParameter, navigate, slug]);
};
